import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// BURGER MENU
    const burgerMenu = document.querySelector(".nav__links"),
    burgerMenuBtn = document.querySelector(".burger__menu");
    
    let burgerMenuSvg = burgerMenuBtn.querySelectorAll("svg");

    burgerMenuBtn.addEventListener("click", function(){
      window.scrollTo({ top: 0, behavior: 'smooth' });
      burgerMenu.classList.toggle("nav__links--hidden");
      for (const svg of burgerMenuSvg) {
          svg.classList.toggle('burger__menu--hidden');
      }
      burgerMenuBtn.classList.toggle("burger__menu--fixed");
  });

  // SHOP TAB MENU
    if (window.location.href.includes("shop")){

    let menuClosed = document.querySelector(".main_menu");
    let menuOpen = document.querySelector(".sub_menu");

    menuClosed.addEventListener("click", function(){
      document.querySelector(".sub_menu").classList.toggle("hidden");
      menuClosed.classList.toggle("rotate");
    })
  }

  // SLIDER GALLERY
    if (window.location.href.includes("gallery")){

    let pages = [
        "Zagreb",
        "Budapest",
        "Perth",
        "Stockholm",
        "Brussels"
      ]
      
      let btnLeft = document.querySelector(".button__left")
      let btnRight = document.querySelector(".button__right")
      let title = document.querySelector(".gallery--country")
      
      let compteur = pages.indexOf(title.textContent)
      
      btnRight.addEventListener("click", () => {
        document.querySelector("."+title.textContent.toLowerCase()+"__content").classList.add("hidden")
        if(pages[compteur+1] === undefined){
          compteur = 0
          title.innerHTML = pages[0]
          document.querySelector("."+pages[0].toLowerCase()+"__content").classList.remove("hidden")
        } else {
          title.innerHTML = pages[compteur+1]
          document.querySelector("."+pages[compteur+1].toLowerCase()+"__content").classList.remove("hidden")
          ++compteur
        }
      })
      
      btnLeft.addEventListener("click", () => {
        document.querySelector("."+title.textContent.toLowerCase()+"__content").classList.add("hidden")
        if(pages[compteur-1] === undefined){
          compteur = pages.length-1
          title.innerHTML = pages[pages.length-1]
          document.querySelector("."+pages[pages.length-1].toLowerCase()+"__content").classList.remove("hidden")
        } else {
          title.innerHTML = pages[compteur-1]
          document.querySelector("."+pages[compteur-1].toLowerCase()+"__content").classList.remove("hidden")
          --compteur
        }
      })
    }

    // ANIMATION GSAP
    function animateFrom(elem, direction) {
      direction = direction || 1;
      var x = 0,
          y = direction * 100;
      if(elem.classList.contains("gs_reveal_fromLeft")) {
        x = -100;
        y = 0;
      } else if (elem.classList.contains("gs_reveal_fromRight")) {
        x = 100;
        y = 0;
      }
      elem.style.transform = "translate(" + x + "px, " + y + "px)";
      elem.style.opacity = "0";
      gsap.fromTo(elem, {x: x, y: y, autoAlpha: 0}, {
        duration: 1.25, 
        x: 0,
        y: 0, 
        autoAlpha: 1, 
        ease: "expo", 
        overwrite: "auto"
      });
    }

  function hide(elem) {
    gsap.set(elem, {autoAlpha: 0});
  }
  
  document.addEventListener("DOMContentLoaded", function() {
    gsap.registerPlugin(ScrollTrigger);
    
    gsap.utils.toArray(".gs_reveal").forEach(function(elem) {
      hide(elem); // assure that the element is hidden when scrolled into view
      
      ScrollTrigger.create({
        trigger: elem,
        onEnter: function() { animateFrom(elem) }, 
        onEnterBack: function() { animateFrom(elem, -1) },
        onLeave: function() { hide(elem) } // assure that the element is hidden when scrolled into view
      });
    });
  });